var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"},on:{"mousewheel":_vm.mouseWheel}},[_vm._t("default"),(_vm.showOverlay)?_c('div',{class:{ background: _vm.title }},[(_vm.title)?_c('span',{staticClass:"hvh-h3",staticStyle:{"color":"white"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }